<script lang="ts">
  import { GraphicBlock } from '@reuters-graphics/graphics-components';

  import data from '../../data/iran-ship-attacks.json';
  import ShipCard, { type Ship } from './ShipCard.svelte';

  const ships = (data.Iran_vessel_strikes_with_types as Ship[]).sort(
    (a, b) =>
      new Date(b.attack_date).getTime() - new Date(a.attack_date).getTime()
  );

  let { block } = $props();
</script>

<GraphicBlock width="wider" class="!my-10" notes={block.notes}>
  <div class="flex ships-container mb-6 mt-8">
    {#each ships as ship}
      <ShipCard {ship} />
    {/each}
  </div>
</GraphicBlock>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  div.ships-container {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem 1rem;
    justify-content: center;
    margin-top: 5rem;
  }
</style>
